import PrispevokVestnikaList from './PrispevokVestnikaList';

export default PrispevokVestnikaList;
